export default __webpack_public_path__ + "static/media/signInBackGround.326ac076.png";